import React, {useState, useEffect, useRef} from 'react'
import { PrizeIntro } from './PrizeIntro'

export const OtherPrizes = ({content, lang}) => {

    return (
        <div className='other-prizes-wrapper'>
            {
                content.map((prize, index) => (
                    <PrizeIntro prize={prize} imageRight={index%2 == 1? true: false} className={`${prize.class_name} ${lang}`} key={index}/>
                ))
            }
        </div>
    )
}